import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';

import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MainLayout } from './layout/Main';
import { myTheme } from './theme';
import { SidebarProvider } from './context/SidebarContext';
import ProfilePage from './pages/ProfilePage/ProfilePage';

import './App.css';
import ResumePage from './pages/ResumePage/ResumePage';
import TechnicalQuestionsPage from './pages/TechnicalQuestionsPage/TechnicalQuestionsPage';
import JobPostsPage from './pages/JobPostsPage/JobPostsPage';
import CoverLetterPage from './pages/CoverLetterPage/CoverLetterPage';
import JobAnalyticsPage from './pages/JobAnalyticsPage/JobAnalyticsPage';
import BehaviouralQuestionsPage from './pages/BehaviouralQuestionsPage/BehaviouralQuestionsPage';
import { ClerkProvider } from '@clerk/clerk-react';
import { trTR, enUS } from '@clerk/localizations';

export default function App() {
  const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY
  const { i18n } = useTranslation();

  return (
    <BrowserRouter>
      <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/" localization={i18n.language === 'tr' ? trTR : enUS}>
        <MantineProvider theme={myTheme} defaultColorScheme="light">
          <ModalsProvider modalProps={{
            overlayProps: {
              backgroundOpacity: 0.55,
              blur: 3
            }
          }}>
            <SidebarProvider>
              <Routes>
                <Route element={<MainLayout />}>
                  <Route path="/" element={<ProfilePage />} />
                  <Route path="/resume" element={<ResumePage />} />
                  <Route path="/job-posts" element={<JobPostsPage />} />
                  <Route path="/cover-letter" element={<CoverLetterPage />} />
                  <Route path="/job-analytics" element={<JobAnalyticsPage />} />
                  <Route path="/technical-questions" element={<TechnicalQuestionsPage />} />
                  <Route path="/behavioural-questions" element={<BehaviouralQuestionsPage />} />
                </Route>
              </Routes>
            </SidebarProvider>
          </ModalsProvider>
        </MantineProvider>
      </ClerkProvider>
    </BrowserRouter>
  );
}